import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope, faMapMarkerAlt, faClock } from "@fortawesome/free-solid-svg-icons";
import flagBrazil from "../../imagens/flags/bandeiraBrasil.png";
import ReCAPTCHA from "react-google-recaptcha";
import "./pageTestContactUs.css";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";

const ContactUsComponent = () => {
  const { t } = useTranslation();
  const [alertMessage, setAlertMessage] = useState(null);
  const [alertType, setAlertType] = useState(null);
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const navigate = useNavigate();

  const isValidDomain = async (email) => {
    const domain = email.split("@")[1];
    try {
      const response = await fetch(`https://dns.google/resolve?name=${domain}&type=MX`);
      const data = await response.json();
      return data.Answer && data.Answer.length > 0;
    } catch (error) {
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);

    const formData = new FormData(e.target);
    const email = formData.get("email");

    if (!(await isValidDomain(email))) {
      setAlertMessage(t("contactUs.invalidDomain"));
      setAlertType("danger");
      setIsSending(false);
      return;
    }

    if (!recaptchaValue) {
      setAlertMessage(t("contactUs.completeRecaptcha"));
      setAlertType("danger");
      setIsSending(false);
      return;
    }

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID_CONTACT_US,
        e.target,
        process.env.REACT_APP_PUBLI
      )
      .then(
        () => {
          setAlertMessage(t("contactUs.success"));
          setAlertType("success");
          e.target.reset();
          setIsSending(false);
          setTimeout(() => navigate("/ContactUs"), 1000);
        },
        (error) => {
          setAlertMessage(t("contactUs.error"));
          setAlertType("danger");
          setIsSending(false);
        }
      );
  };

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  return (
    <div>
      <section className="container w-100">
        <div className="row">
          <h2 className="bgColorCustom text-center my-4">{t("contactUs.title")}</h2>

          <div className="col-lg-6 col-md-12 mb-4 p-0 d-flex justify-content-center align-items-center">
            <div className="contact-card w-75 p-4 pt-4 align-items-center justify-content-center">
              <div className="d-flex align-items-center mb-5">
                <img
                  src={flagBrazil}
                  alt={t("contactUs.flagAlt")}
                  className="me-4 rounded"
                  style={{ width: "50px", height: "35px", objectFit: "cover" }}
                />
                <h4 className="m-0 mb-3 fw-bold text-custom">
                  <span className="mg-text">MG</span>
                  <span className="sul-text"> SUL</span>
                  <br />
                  <span className="text-custom">{t("contactUs.companyDescription")}</span>
                </h4>
              </div>

              <p className="text-custom fw-bold">{t("contactUs.contactText")}</p>

              <ul className="list-unstyled text-dark">
                <li className="mb-2">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 text-red" />
                  <strong>{t("contactUs.address")}:</strong> R. Angelina Resende de Almeida, 333 - Ouro Fino, MG, 37570-000
                </li>
                <li className="mb-2">
                  <FontAwesomeIcon icon={faPhone} className="me-2 text-red" />
                  <strong>{t("contactUs.phone")}:</strong> (35) 3333-3333
                </li>
                <li className="mb-2">
                  <FontAwesomeIcon icon={faEnvelope} className="me-2 text-red" />
                  <strong>{t("contactUs.email")}:</strong> contato@mgsul.com.br
                </li>
                <li className="mb-2">
                  <FontAwesomeIcon icon={faClock} className="me-2 text-red" />
                  <strong>{t("contactUs.hours")}:</strong> {t("contactUs.workingHours")}
                </li>

              </ul>

              <a
                href="https://www.google.com/maps/place/MG+SUL+Sistemas+Automotivos/@-22.2700837,-46.3725355,17z/data=!3m1!4b1!4m6!3m5!1s0x94c97750f2fd4ef7:0x6d5f8505a9504627!8m2!3d-22.2700837!4d-46.3699606!16s%2Fg%2F1td1q_dj?entry=ttu&g_ep=EgoyMDI1MTEyMy4xIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-contactUsCard w-auto align-self-center"
              >
                {t("contactUs.viewOnMaps")}
              </a>
            </div>
          </div>

          <div className="col-lg-6 col-md-12">


            <form onSubmit={handleSubmit}>
              <h2 className="text-center bgColorCustom">{t("contactUs.formTitle")}</h2>
              <div className="mb-3">
                <label htmlFor="name" className="form-label">{t("contactUs.name")}</label>
                <input type="text" id="name" name="name" className="form-control" required />
              </div>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">{t("contactUs.emailLabel")}</label>
                <input type="email" id="email" name="email" className="form-control" required />
              </div>
              <div className="mb-3">
                <label htmlFor="Number" className="form-label">{t("contactUs.number")}</label>
                <input id="Number" name="Number" className="form-control" required />
              </div>
              <div className="mb-3">
                <label htmlFor="subject" className="form-label">{t("contactUs.subject")}</label>
                <input id="subject" name="subject" className="form-control" required />
              </div>
              <div className="mb-3">
                <label htmlFor="message" className="form-label">{t("contactUs.message")}</label>
                <textarea id="message" name="message" className="form-control" rows="5" required></textarea>
              </div>
              <div className="mb-3">
                <ReCAPTCHA sitekey="6LfltZkqAAAAAMl7b8dSoSs0zqfmtW07rtqST7cb" onChange={handleRecaptchaChange} />
              </div>
              <button type="submit" className="btn btn-contactUsCard mb-3" disabled={isSending}>
                {isSending ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : t("contactUs.sendMessage")}
              </button>
              {isSending && <p className="text-info">{t("contactUs.sendingMessage")}</p>}
              {alertMessage && (
                <div className={`alert alert-${alertType} mt-3`} role="alert">
                  {alertMessage}
                </div>
              )}
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUsComponent;
